import { host } from '../../../config'

export function getCleanedHost (url) {
  return url.replace(/^(https?:\/\/)?(www[-a-z]*\.)?/, '')
}

function handleHref (href) {
  const cleanedHost = getCleanedHost(host)
  if (!href) {
    return ''
    /* eslint-disable no-template-curly-in-string */
  } else if (!href.includes('${baseUrl}')) {
    return href
  } else {
    /* eslint-disable no-template-curly-in-string */
    const url = href.replace('${baseUrl}', cleanedHost)
    return url
  }
}

function handleSubTitle (str, categoryName) {
  if (!str) {
    return ''
    /* eslint-disable no-template-curly-in-string */
  } else if (!str.includes('${categoryName}')) {
    return str
  } else {
    /* eslint-disable no-template-curly-in-string */
    const res = str.replace('${categoryName}', categoryName)
    return res
  }
}

const componentTemplate = (categoryId, categoryName, template) => {
  const componentOverrides = (props) => ({
    SubTitle: {
      props: {
        title: handleSubTitle(props?.title, categoryName)
      }
    },
    GamesRow: {
      props: {
        listId: 'TopGames',
        query: { categoryId, sort: 'order', limit: 4 }
      }
    },
    CallToAction: {
      props: {
        href: handleHref(props?.href)
      }
    }
  })
  const newData = []
  const templateComponents = template?.components || template || []
  for (const element of templateComponents) {
    if (componentOverrides(element.props)[element.type]) {
      element.props = {
        ...element.props,
        ...componentOverrides(element.props)[element.type].props
      }
    }
    newData.push(element)
  }
  return newData
}

export default componentTemplate
